import { Injectable } from '@angular/core';

import { TranslationService } from '@alfresco/adf-core';

@Injectable({
  providedIn: 'root',
})
export class WkTranslationService {
  constructor(private readonly translationService: TranslationService) {}

  instant(key: string | string[], interpolateParams: Object = null): any {
    return this.translationService.instant(key, interpolateParams);
  }
}
